import { useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import type { Broadcast } from '@/features/broadcasts/broadcasts-types';

export const SendBroadcastDialog = ({
  broadcast,
  onConfirm,
  onOpenChange,
}: {
  broadcast: Broadcast;
  onConfirm: (scheduledLocalAt?: string) => void;
  onOpenChange: (open: boolean) => void;
}) => {
  const [scheduledLocalAt, setScheduledLocalAt] = useState('');

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Send {broadcast.title}?</DialogTitle>
          <DialogDescription>
            This queues the exact message for users enabled by{' '}
            <span className="font-mono">{broadcast.flag_key}</span>. It cannot
            be edited after sending starts.
          </DialogDescription>
        </DialogHeader>
        <p className="whitespace-pre-wrap rounded-md bg-muted px-4 py-3">
          {broadcast.text}
        </p>
        <label className="space-y-2 text-sm font-medium">
          Schedule for
          <Input
            type="datetime-local"
            value={scheduledLocalAt}
            onChange={(event) => setScheduledLocalAt(event.target.value)}
          />
          <span className="block font-normal text-muted-foreground">
            This date and time is applied in each recipient&apos;s timezone.
          </span>
        </label>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="outline">
              Cancel
            </Button>
          </DialogClose>
          <Button type="button" variant="outline" onClick={() => onConfirm()}>
            Send in 2 minutes
          </Button>
          <Button
            type="button"
            disabled={!scheduledLocalAt}
            onClick={() => onConfirm(scheduledLocalAt)}
          >
            Schedule
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
